import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {VerityPricesTableComponent} from './components/verity-prices-table/verity-prices-table.component';
import {NetPricesComponent} from './components/net-prices/net-prices.component';
import {ChangelogComponent} from './components/changelog/changelog.component';
import {PriceChangesComponent} from './components/price-changes/price-changes.component';
import {UnitPricesComponent} from './components/unit-prices/unit-prices.component';
import {PricesComponent} from './components/boot/prices.component';
import {NetPricesGuardService} from '../utils/guards/net-prices-guard.service';

const pricesViewRoutes: Routes = [
  {
    path: '',
    component: PricesComponent,
    children: [
      {
        path: '',
        component: VerityPricesTableComponent
      },
      {
        path: 'net-prices',
        component: NetPricesComponent,
        canActivate: [NetPricesGuardService]
      },
      {
        path: 'changelog',
        component: ChangelogComponent
      },
      {
        path: 'price-changes',
        component: PriceChangesComponent
      },
      {
        path: 'unit-prices',
        component: UnitPricesComponent
      },
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(pricesViewRoutes)
  ], exports: [
    RouterModule
  ]
})
export class PricesViewRouterModule {
}
